"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceEstimateDtoPriceConfidenceEnum = void 0;
exports.instanceOfPriceEstimateDto = instanceOfPriceEstimateDto;
exports.PriceEstimateDtoFromJSON = PriceEstimateDtoFromJSON;
exports.PriceEstimateDtoFromJSONTyped = PriceEstimateDtoFromJSONTyped;
exports.PriceEstimateDtoToJSON = PriceEstimateDtoToJSON;
exports.PriceEstimateDtoToJSONTyped = PriceEstimateDtoToJSONTyped;
/**
 * @export
 */
exports.PriceEstimateDtoPriceConfidenceEnum = {
    High: 'high',
    Medium: 'medium',
    Low: 'low'
};
/**
 * Check if a given object implements the PriceEstimateDto interface.
 */
function instanceOfPriceEstimateDto(value) {
    return true;
}
function PriceEstimateDtoFromJSON(json) {
    return PriceEstimateDtoFromJSONTyped(json, false);
}
function PriceEstimateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'] == null ? undefined : json['date'],
        'lowerPrice': json['lowerPrice'] == null ? undefined : json['lowerPrice'],
        'midPrice': json['midPrice'] == null ? undefined : json['midPrice'],
        'priceConfidence': json['priceConfidence'] == null ? undefined : json['priceConfidence'],
        'source': json['source'] == null ? undefined : json['source'],
        'upperPrice': json['upperPrice'] == null ? undefined : json['upperPrice'],
    };
}
function PriceEstimateDtoToJSON(json) {
    return PriceEstimateDtoToJSONTyped(json, false);
}
function PriceEstimateDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'lowerPrice': value['lowerPrice'],
        'midPrice': value['midPrice'],
        'priceConfidence': value['priceConfidence'],
        'source': value['source'],
        'upperPrice': value['upperPrice'],
    };
}
